import React, {useEffect, useRef, useState} from "react";

type TruncatedTextProps = {
    text: string;
    className?: string;
    truncateLeft?: boolean;
};

const TruncatedText: React.FC<TruncatedTextProps> = ({ text, className = "", truncateLeft = false }) => {
    const ref = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return () => { /* */};

        const checkTruncation = () => {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        };

        checkTruncation();

        const observer = new ResizeObserver(checkTruncation);
        observer.observe(el);

        return () => observer.disconnect();
    }, [text]);

    return (
        <span
            ref={ref}
            className={`${truncateLeft ? 'block overflow-hidden whitespace-nowrap text-ellipsis text-left [direction:rtl]' : 'truncate'} ${className}`}
            title={isTruncated ? text : undefined}
        >
      {text}
    </span>
    );
}

export default TruncatedText;